
<template>
  <b-modal
    v-model="showModal"
    :title="
      $t('Reset Password') +
      ': ' +
      (user.full_name == undefined ? user.fullName : user.full_name)
    "
    modal-class="modal-primary"
    hide-footer
    @hidden="hideModal"
  >
    <validation-observer ref="simpleRules" #default="{ invalid }">
      <b-form @submit.prevent="validationForm">
        <!-- password -->
        <b-form-group
          :label="$t('New Password')"
          label-for="reset-password-new"
        >
          <validation-provider
            #default="{ errors }"
            name="Password"
            vid="Password"
            rules="required|min:8|max:255"
          >
            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid' : null"
            >
              <b-form-input
                id="reset-password-new"
                v-model="password"
                :type="password1FieldType"
                :state="errors.length > 0 ? false : null"
                class="form-control-merge"
                name="reset-password-new"
                placeholder="············"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="password1ToggleIcon"
                  @click="togglePassword1Visibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- confirm password -->
        <b-form-group
          label-for="reset-password-confirm"
          :label="$t('Confirm Password')"
        >
          <validation-provider
            #default="{ errors }"
            name="Confirm Password"
            rules="required|confirmed:Password|min:8|max:255"
          >
            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid' : null"
            >
              <b-form-input
                id="reset-password-confirm"
                v-model="cPassword"
                :type="password2FieldType"
                class="form-control-merge"
                :state="errors.length > 0 ? false : null"
                name="reset-password-confirm"
                placeholder="············"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="password2ToggleIcon"
                  @click="togglePassword2Visibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <!-- submit button -->
        <b-button
          block
          type="submit"
          variant="outline-primary"
          :disabled="invalid"
        >
          {{ $t("Save New Password") }}
        </b-button>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BCardTitle,
  BCardText,
  BForm,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BFormInput,
  BButton,
  BImg,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import UserService from "@/views/users/views/list/services/users.services.js";

export default {
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },

  components: {
    BRow,
    BCol,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BImg,
    BInputGroup,
    BLink,
    BFormInput,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      showModal: true,
      userEmail: "",
      cPassword: "",
      password: "",
      required,
      password1FieldType: "password",
      password2FieldType: "password",
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password1ToggleIcon() {
      return this.password1FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password2ToggleIcon() {
      return this.password2FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  methods: {
    hideModal() {
      this.$emit("close");
    },
    togglePassword1Visibility() {
      this.password1FieldType =
        this.password1FieldType === "password" ? "text" : "password";
    },
    togglePassword2Visibility() {
      this.password2FieldType =
        this.password2FieldType === "password" ? "text" : "password";
    },
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.resetPassword();
        }
      });
    },
    async resetPassword() {
      try {
        this.addPreloader();
        const { data, status } = await UserService.forceChangePassword({
          id: this.user.id,
          password: this.password,
        });
        if (status === 200) {
          if (this.user.id == this.currentUser.id) {
            this.removeLocalStorage();
          }
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Success",
              icon: "CheckIcon",
              variant: "success",
              text: data,
            },
          });
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error,
          },
        });
      } finally {
        this.removePreloader();
        this.hideModal();
      }
    },

    removeLocalStorage() {
      localStorage.removeItem("userData");
      localStorage.removeItem("accessToken");
      window.location.reload();
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
